module.exports = __webpack_public_path__ + "assets/img/417791ae55730bcdbe29a84ce46429f4.png";